export default {
	editor: {
		placeholderText: 'Bitte geben Sie hier Ihren Text ein...',
	},
}
